module.exports = __webpack_public_path__ + "static/media/powdamap_logo.0e1f6ab1.png";